<template>
  <icon
    set="outline"
    name="refresh"
    class="animate-reverse-spin-slow h-5 w-5"
  />
</template>
<script>
export default {
  name: "LoadingSpinner",
};
</script>
